import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import CuratedCollections from "./sections/CuratedCollections";
import IndustryCollaborations from "./sections/IndustryCollaborations";
import SpecializedAiSolutions from "./sections/SpecializedAiSolutions";
import StudioCompatibility from "./sections/StudioCompatibility";
import ClientTestimonials from "./sections/ClientTestimonials";
import ReadyToProtectYourRoof from "./sections/ReadyToProtectYourRoof";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <CuratedCollections />
      <IndustryCollaborations />
      <SpecializedAiSolutions />
      <StudioCompatibility />
      <ClientTestimonials />
      <ReadyToProtectYourRoof />
      <Footer />
    </div>;
}